import styles from './index.scss'
import { Button, Toast } from 'antd-mobile'
import { useEffect, useState } from 'react'
import { equityListCategory, couponListMyCoupon } from '@/services'
import goTo from '@/libs/functions/goTo'
import Layout from '@/libs/components/Layout'
import { getUrlAllParams } from '@/libs/functions/getValue'
import DiscountCouponCard from '@/libs/components/DiscountCouponCard'
import { onGotoGoodsDetail } from '@/libs/functions/tools'
import { getUrlParam } from '@/libs/functions/getValue'

export default function DiscountCouponList() {
  const title = getUrlParam('title') as any
  const [listData, setListData] = useState<any>([])

  useEffect(() => {
    couponListMyCoupon({
      status: 0,
    }).then((res) => {
      setListData(res)
    })
  }, [])

  const toUse = (code: string, equityCouponUrl: string, proCode: string) => {}

  return (
    <Layout title={title || '优惠券'}>
      <div className={styles.couponListPage}>
        <div className={styles.list}>
          {listData.length > 0 &&
            listData.map((v: any) => (
              <DiscountCouponCard
                key={v.id}
                data={v}
                currencySymbol={v.currencySymbol || '¥'}
                onConfirm={() => {
                  const {
                    categoryType,
                    proCode,
                    redirectUrl,
                    id,
                    virtuallyType,
                  } = v
                  if (redirectUrl) {
                    goTo(redirectUrl)
                    return
                  }
                  if (proCode) {
                    onGotoGoodsDetail(virtuallyType || categoryType, proCode)
                    return
                  }
                  goTo(`/discountCouponGoodsList?couponMemberId=${id}`)
                }}
              />
            ))}
          {listData.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              暂无服务记录
            </div>
          )}
        </div>
        <div
          className={styles.failure}
          onClick={() => goTo(`/historyDiscountCouponList`)}
        >
          <div>查看历史优惠券</div>
          <img
            className={styles.icon}
            src={require('@/assets/image/ico_enter.png')}
          />
        </div>
      </div>
    </Layout>
  )
}
